'use strict';

import Styles from './less/core.less';



// WEBPACK FOOTER //
// ./app/components/staff-contact/main.js